import axios from 'axios'
import {handleError} from '../handleError'
import {LError} from '../../object'
const state = {

}
const getters = {

}
const mutations = {

}
const actions = {
  /* 获取园区列表 */
  async getParkList ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/parkApi/smaco/park/park/list',
      pagination,
      sortStack,
      search,
      filter: filter || {}
    }, {root: true})
    return {
      items,
      amount
    }
  },
  /* 获取有向卡口列表 */
  async getDirControllerList ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/parkApi/smaco/park/dirgate/list',
      pagination,
      sortStack,
      search,
      filter: filter || {}
    }, {root: true})
    return {
      items,
      amount
    }
  },
  /* 获取无向卡口列表 */
  async getUnDirControllerList ({dispatch}, {pagination, sortStack, search, filter}) {
    let {items, amount} = await dispatch('getDataList', {
      url: '/parkApi/smaco/park/gate/list',
      pagination,
      sortStack,
      search,
      filter: filter || {}
    }, {root: true})
    return {
      items,
      amount
    }
  },
  /* 新增园区 */
  async addPark ({dispatch}, params) {
    let url = '/parkApi/smaco/park/park'
    try {
      let res = await axios.post(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 修改园区 */
  async updateParkInfo ({dispatch}, params) {
    let url = '/parkApi/smaco/park/park'
    try {
      let res = await axios.put(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 删除园区 */
  async deletePark ({dispatch}, ids) {
    let url = '/parkApi/smaco/park/park'
    try {
      let res = await axios.delete(url, {data: {
        'ids': ids
      }})
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 添加无方向卡口 */
  async addUnDirController ({dispatch}, params) {
    let url = '/parkApi/smaco/park/gate'
    try {
      let res = await axios.post(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 更新无方向卡口 */
  async updateUnDirController ({dispatch}, params) {
    let url = '/parkApi/smaco/park/gate'
    try {
      let res = await axios.put(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 删除无方向卡口 */
  async deleteUnDirController ({dispatch}, ids) {
    let url = '/parkApi/smaco/park/gate'
    try {
      let res = await axios.delete(url, {data: {
        'ids': ids
      }})
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 添加有方向卡口 */
  async addDirController ({dispatch}, params) {
    let url = '/parkApi/smaco/park/dirgate'
    try {
      let res = await axios.post(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 更新有方向卡口 */
  async updateDirController ({dispatch}, params) {
    let url = '/parkApi/smaco/park/dirgate'
    try {
      let res = await axios.put(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 删除有方向卡口 */
  async deleteDirController ({dispatch}, ids) {
    let url = '/parkApi/smaco/park/dirgate'
    try {
      let res = await axios.delete(url, {data: {
        'ids': ids
      }})
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
}
export default{
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
